/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientMedicationValue } from './PatientMedicationValue';
import {
    PatientMedicationValueFromJSON,
    PatientMedicationValueFromJSONTyped,
    PatientMedicationValueToJSON,
} from './PatientMedicationValue';

/**
 * 
 * @export
 * @interface PatientMedicationHistory
 */
export interface PatientMedicationHistory {
    /**
     * 
     * @type {number}
     * @memberof PatientMedicationHistory
     */
    date: number;
    /**
     * 
     * @type {string}
     * @memberof PatientMedicationHistory
     */
    author_role?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedicationHistory
     */
    author_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedicationHistory
     */
    action: string;
    /**
     * 
     * @type {PatientMedicationValue}
     * @memberof PatientMedicationHistory
     */
    value: PatientMedicationValue;
}

/**
 * Check if a given object implements the PatientMedicationHistory interface.
 */
export function instanceOfPatientMedicationHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function PatientMedicationHistoryFromJSON(json: any): PatientMedicationHistory {
    return PatientMedicationHistoryFromJSONTyped(json, false);
}

export function PatientMedicationHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientMedicationHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'author_role': !exists(json, 'author_role') ? undefined : json['author_role'],
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'action': json['action'],
        'value': PatientMedicationValueFromJSON(json['value']),
    };
}

export function PatientMedicationHistoryToJSON(value?: PatientMedicationHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'author_role': value.author_role,
        'author_id': value.author_id,
        'action': value.action,
        'value': PatientMedicationValueToJSON(value.value),
    };
}

